export default "__VITE_ASSET__$3sn6V7k__"